(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_f7e532e"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__irandreFooterBrandRevealInitialized) return;

    const initializeFooterBrand = () => {
      window.__irandreFooterBrandRevealInitialized = true;

      const brands = document.querySelectorAll('.footer-brand');
      if (!brands.length) return;

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const createHeartBurst = (brand) => {
      if (reduceMotion) return;

      const layer = brand.querySelector('.footer-brand__heart-layer');
      if (!layer) return;

      const colors = ['#b85c6d', '#d98a98', '#f0b6bd', '#8f4d5c', '#fff0e8'];
      const heart = document.createElement('span');
      heart.className = 'footer-brand__heart';
      heart.textContent = '♥';
      heart.style.setProperty('--heart-color', colors[Math.floor(Math.random() * colors.length)]);
      heart.style.setProperty('--heart-size', `${26 + Math.random() * 22}px`);
      heart.style.setProperty('--heart-x', `${(Math.random() - 0.5) * 300}px`);
      heart.style.setProperty('--heart-y', `${-42 - Math.random() * 145}px`);
      heart.style.setProperty('--heart-rotation', `${-35 + Math.random() * 70}deg`);
      heart.style.setProperty('--heart-delay', `${Math.random() * 80}ms`);
      layer.appendChild(heart);
      window.setTimeout(() => heart.remove(), 1350);
    };

    brands.forEach((brand) => {
      brand.addEventListener('pointerdown', () => createHeartBurst(brand), { passive: true });
    });

    if (reduceMotion) {
      brands.forEach((brand) => brand.classList.add('footer-brand--revealed'));
      return;
    }

    const observer = new IntersectionObserver(
      (entries, currentObserver) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add(entry.target.dataset.revealClass || 'footer-brand--revealed');
          currentObserver.unobserve(entry.target);
        });
      },
      { threshold: 0.22, rootMargin: '0px 0px -8% 0px' }
    );

    brands.forEach((brand) => observer.observe(brand));

    const revealVisibleBrands = () => {
      brands.forEach((brand) => {
        const rect = brand.getBoundingClientRect();
        if (rect.top < window.innerHeight * 1.1 && rect.bottom > 0) {
          brand.classList.add(brand.dataset.revealClass || 'footer-brand--revealed');
          observer.unobserve(brand);
        }
      });
    };

    const scrollTargets = [window, document.querySelector('.page-wrapper')].filter(Boolean);
    scrollTargets.forEach((target) => target.addEventListener('scroll', revealVisibleBrands, { passive: true }));
    window.addEventListener('resize', revealVisibleBrands, { passive: true });
      window.setTimeout(revealVisibleBrands, 100);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeFooterBrand, { once: true });
    } else {
      initializeFooterBrand();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["irandre-delivery-timeline"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('irandre-delivery-timeline')) {
    customElements.define('irandre-delivery-timeline', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.locale = document.documentElement.lang || 'en-US';
        this.cutoffHour = Number(this.dataset.cutoffHour || 14);
        this.renderDates();
        this.updateCountdown();
        this.timer = window.setInterval(() => this.updateCountdown(), 1000);
      }

      disconnectedCallback() {
        window.clearInterval(this.timer);
      }

      isBusinessDay(date) {
        return date.getDay() !== 0 && date.getDay() !== 6;
      }

      addBusinessDays(date, amount) {
        const result = new Date(date);
        let remaining = amount;
        while (remaining > 0) {
          result.setDate(result.getDate() + 1);
          if (this.isBusinessDay(result)) remaining -= 1;
        }
        return result;
      }

      nextCutoff(now) {
        const target = new Date(now);
        target.setHours(this.cutoffHour, 0, 0, 0);
        if (!this.isBusinessDay(target) || now >= target) {
          do {
            target.setDate(target.getDate() + 1);
          } while (!this.isBusinessDay(target));
          target.setHours(this.cutoffHour, 0, 0, 0);
        }
        return target;
      }

      formatDate(date) {
        return new Intl.DateTimeFormat(this.locale, { month: 'short', day: 'numeric' }).format(date);
      }

      formatRange(start, end) {
        const formatter = new Intl.DateTimeFormat(this.locale, { month: 'short', day: 'numeric' });
        return typeof formatter.formatRange === 'function'
          ? formatter.formatRange(start, end)
          : `${formatter.format(start)} – ${formatter.format(end)}`;
      }

      renderDates() {
        const now = new Date();
        const orderDate = new Date(now);
        const processingMin = Number(this.dataset.processingMin || 1);
        const processingMax = Number(this.dataset.processingMax || 3);
        const deliveryMin = Number(this.dataset.deliveryMin || 3);
        const deliveryMax = Number(this.dataset.deliveryMax || 8);
        const preparationStart = this.addBusinessDays(orderDate, processingMin);
        const preparationEnd = this.addBusinessDays(orderDate, processingMax);
        const deliveryStart = this.addBusinessDays(preparationStart, deliveryMin);
        const deliveryEnd = this.addBusinessDays(preparationEnd, deliveryMax);
        const orderText = this.formatDate(orderDate);
        const preparationText = this.formatRange(preparationStart, preparationEnd);
        const deliveryText = this.formatRange(deliveryStart, deliveryEnd);
        this.querySelector('[data-order-date]').textContent = orderText;
        this.querySelector('[data-preparation-date]').textContent = preparationText;
        this.querySelector('[data-delivery-date]').textContent = deliveryText;
        this.querySelector('[data-delivery-accessible]').textContent = `${this.querySelector('[data-delivery-date]').previousElementSibling.textContent}: ${deliveryText}`;
      }

      updateCountdown() {
        const now = new Date();
        const target = this.nextCutoff(now);
        const isToday = target.toDateString() === now.toDateString();
        const difference = Math.max(0, target.getTime() - now.getTime());
        const hours = Math.floor(difference / 3600000);
        const minutes = Math.floor((difference % 3600000) / 60000);
        const seconds = Math.floor((difference % 60000) / 1000);
        const countdown = [hours, minutes, seconds].map((value) => String(value).padStart(2, '0')).join(':');
        this.querySelector('[data-delivery-countdown]').textContent = countdown;
        this.querySelector('[data-delivery-message]').textContent = isToday ? this.dataset.todayPrefix : this.dataset.nextPrefix;
        this.querySelector('[data-delivery-message-end]').textContent = isToday ? this.dataset.todaySuffix : this.dataset.nextSuffix;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["irandre-tryon-cta"] && !Shopify.designMode) return;
  try {
    class IrandreProductTryon extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.button = this.querySelector('[data-tryon-launch]');
      this.label = this.querySelector('[data-tryon-label]');
      this.status = this.querySelector('[data-tryon-status]');
      this.button?.addEventListener('click', () => this.openStudio());
    }

    async openStudio() {
      if (this.pending) return;
      const form = this.closest('.product-details')?.querySelector(`product-form-component[data-product-id="${this.dataset.productId}"]`);
      const variantId = form?.querySelector('form input[name="id"]')?.value;
      const addButton = form?.querySelector('button[name="add"]');
      if (!variantId || !addButton || addButton.disabled) {
        this.status.textContent = this.dataset.unavailable;
        this.status.hidden = false;
        return;
      }

      this.pending = true;
      this.button.disabled = true;
      this.status.hidden = true;
      const originalLabel = this.label.textContent;
      this.label.textContent = this.dataset.loading;

      try {
        const root = window.Shopify?.routes?.root || '/';
        const cartRoot = root.endsWith('/') ? root : `${root}/`;
        const cartResponse = await fetch(`${cartRoot}cart.js`, { credentials: 'same-origin' });
        if (!cartResponse.ok) throw new Error();
        const cart = await cartResponse.json();
        const alreadyAdded = cart.items?.some((item) => String(item.variant_id) === String(variantId));

        if (!alreadyAdded) {
          const addResponse = await fetch(`${cartRoot}cart/add.js`, {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
          });
          if (!addResponse.ok) throw new Error();
        }

        const destination = new URL(this.dataset.tryonUrl, window.location.origin);
        destination.searchParams.set('tryon_variant', variantId);
        window.location.assign(destination.href);
      } catch {
        this.status.textContent = this.dataset.error;
        this.status.hidden = false;
      } finally {
        this.pending = false;
        this.button.disabled = false;
        this.label.textContent = originalLabel;
      }
    }
  }

  if (!customElements.get('irandre-product-tryon')) customElements.define('irandre-product-tryon', IrandreProductTryon);
  } catch(e) { console.error(e); }
})();

})();
